"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TenancyStatus = exports.PropertyStatus = exports.FurnishingTypeEnum = exports.TenureTypeEnum = exports.LandTitleTypeEnum = exports.PropertyTitleTypeEnum = exports.PropertyTypeEnum = void 0;
/* eslint-disable no-unused-vars */
var PropertyTypeEnum;
(function (PropertyTypeEnum) {
    PropertyTypeEnum[PropertyTypeEnum["Apartment"] = 0] = "Apartment";
    PropertyTypeEnum[PropertyTypeEnum["Landed"] = 1] = "Landed";
})(PropertyTypeEnum = exports.PropertyTypeEnum || (exports.PropertyTypeEnum = {}));
var PropertyTitleTypeEnum;
(function (PropertyTitleTypeEnum) {
    PropertyTitleTypeEnum[PropertyTitleTypeEnum["Strata"] = 0] = "Strata";
    PropertyTitleTypeEnum[PropertyTitleTypeEnum["Master"] = 1] = "Master";
    PropertyTitleTypeEnum[PropertyTitleTypeEnum["Individual"] = 2] = "Individual";
})(PropertyTitleTypeEnum = exports.PropertyTitleTypeEnum || (exports.PropertyTitleTypeEnum = {}));
var LandTitleTypeEnum;
(function (LandTitleTypeEnum) {
    LandTitleTypeEnum[LandTitleTypeEnum["Residential"] = 0] = "Residential";
    LandTitleTypeEnum[LandTitleTypeEnum["Commercial"] = 1] = "Commercial";
})(LandTitleTypeEnum = exports.LandTitleTypeEnum || (exports.LandTitleTypeEnum = {}));
var TenureTypeEnum;
(function (TenureTypeEnum) {
    TenureTypeEnum[TenureTypeEnum["FreeHold"] = 0] = "FreeHold";
    TenureTypeEnum[TenureTypeEnum["LeaseHold"] = 1] = "LeaseHold";
})(TenureTypeEnum = exports.TenureTypeEnum || (exports.TenureTypeEnum = {}));
var FurnishingTypeEnum;
(function (FurnishingTypeEnum) {
    FurnishingTypeEnum[FurnishingTypeEnum["Fully"] = 0] = "Fully";
    FurnishingTypeEnum[FurnishingTypeEnum["Partial"] = 1] = "Partial";
    FurnishingTypeEnum[FurnishingTypeEnum["None"] = 2] = "None";
})(FurnishingTypeEnum = exports.FurnishingTypeEnum || (exports.FurnishingTypeEnum = {}));
var PropertyStatus;
(function (PropertyStatus) {
    PropertyStatus[PropertyStatus["pendingApproval"] = 0] = "pendingApproval";
    PropertyStatus[PropertyStatus["vacant"] = 1] = "vacant";
    PropertyStatus[PropertyStatus["tenanted"] = 2] = "tenanted";
    PropertyStatus[PropertyStatus["rejected"] = 3] = "rejected";
    PropertyStatus[PropertyStatus["draftProperty"] = 4] = "draftProperty";
    PropertyStatus[PropertyStatus["approved"] = 5] = "approved";
    PropertyStatus[PropertyStatus["deactivated"] = 6] = "deactivated";
})(PropertyStatus = exports.PropertyStatus || (exports.PropertyStatus = {}));
var TenancyStatus;
(function (TenancyStatus) {
    TenancyStatus[TenancyStatus["Pending"] = 0] = "Pending";
    TenancyStatus[TenancyStatus["Available"] = 1] = "Available";
    TenancyStatus[TenancyStatus["NotAvailable"] = 2] = "NotAvailable";
    TenancyStatus[TenancyStatus["Tenanted"] = 3] = "Tenanted";
})(TenancyStatus = exports.TenancyStatus || (exports.TenancyStatus = {}));
